









































































































import { Component, Vue, Watch } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import GenericAdd from "@/core/Generics/GenericAdd";
import AnnoucementType from "@/models/annoucement/annoucementType.model";
@Component
export default class AnnoucementTypeAdd extends GenericAdd<AnnoucementType> {
  constructor() {
    super();
    this.controller = "AnnoucementType";
    this.model = new AnnoucementType();
  }
}
